import { get } from 'lodash';
import { PostRecord } from 'src/lib/api/PostRecord';
import { APIS } from 'src/lib/constants/apis';
import { KOSTEN_ARTEN, KOSTEN_POSITION, KOSTENTRAEGER } from 'src/lib/constants/constant';
import { getInitialKostenKategorieID } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { getFieldNamefromDataPath, groupKostenByPosition } from 'src/utils/helper';

// import schemas
import KostenPostionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const KP_P = KostenPostionSchema.attributes;

export const handleCreateKostenPositions = async (organisationId: number, appId: number, kostenKategoreis: any[], customKostenArtenArr?: any[]) => {
	const kostenKategoriesGroup = groupKostenByPosition(kostenKategoreis || []);
	const basePositionsData = {
		[getFieldNamefromDataPath(KP_P.Foerderantrag.path)]: appId,
		[getFieldNamefromDataPath(KP_P.Allgemein_Kostentraeger.path)]: KOSTENTRAEGER.Antragsteller,
		[getFieldNamefromDataPath(KP_P.Unternehmen.path)]: organisationId,
		[getFieldNamefromDataPath(KP_P.Allgemein_Kostenposition.path)]: KOSTEN_POSITION.Ausgabe,
	};

	const kostenArten = customKostenArtenArr || [
		KOSTEN_ARTEN.Personalkosten,
		KOSTEN_ARTEN.Sachkosten,
		KOSTEN_ARTEN.Investitionskosten,
		KOSTEN_ARTEN.Reisekosten,
		KOSTEN_ARTEN.Verwaltungskostenpauschale,
		KOSTEN_ARTEN.Eigenmittel,
	];

	for (const kostenArt of kostenArten) {
		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(kostenArt)) {
			const filteredKategoriesAusgabe = kostenKategoreis.filter(
				(item: any) =>
					get(item, KP_P.Allgemein_Kostenart_Finanzierung.path) === kostenArt &&
					get(item, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe,
			);
			const defaultKostenkategorieId = getInitialKostenKategorieID(filteredKategoriesAusgabe);

			await PostRecord(APIS.Kostenposition, {
				data: {
					...basePositionsData,
					[getFieldNamefromDataPath(KP_P.Allgemein_Kostenkategorie.path)]: defaultKostenkategorieId,
					[getFieldNamefromDataPath(KP_P.Allgemein_Kostenart_Finanzierung.path)]: kostenArt,
				},
			});
		}
		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(kostenArt)) {
			const filteredKategoriesAusgabe = kostenKategoreis.filter(
				(item: any) =>
					get(item, KP_P.Allgemein_Kostenart_Finanzierung.path) === kostenArt &&
					get(item, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Einnahme,
			);
			const defaultKostenkategorieId = getInitialKostenKategorieID(filteredKategoriesAusgabe);

			await PostRecord(APIS.Kostenposition, {
				data: {
					...basePositionsData,
					[getFieldNamefromDataPath(KP_P.Allgemein_Kostenkategorie.path)]: defaultKostenkategorieId,
					[getFieldNamefromDataPath(KP_P.Mitteilung_Anderer_Einrichtungen.path)]: {
						Fragen_Block_1: [{ Zelle_1: '' }],
					},
					[getFieldNamefromDataPath(KP_P.Allgemein_Kostenposition.path)]: KOSTEN_POSITION.Einnahme,
					[getFieldNamefromDataPath(KP_P.Allgemein_Kostenart_Finanzierung.path)]: kostenArt,
				},
			});
		}
	}
};
